import router from './index'
import store from '../store'
import VueJwtDecode from 'vue-jwt-decode'
import VueCookies from 'vue-cookies'

const onBoardUrl = '/fo/onboarding'
const onNickname = '/fo/nickNameJoin'
const travelCompleteUrl = '/fo/travelComplete'
let termsSheetUrl = '/fo/join/termsSheet'
const checkChangePasswordUrl = '/fo/join/checkChangePassword'

const WHITE_URL = ['/404', '/com-error', '/exp-error', '/push-test-page', '/cert-test-page']
const JOIN_URL = '/fo/join'

router.beforeEach(async (to, from, next) => {
  // 중복로그인 체크용
  if (VueCookies.isKey('dms-duplicate-user')) {
    store.dispatch('logout', "9777")
    return
  }

  if (WHITE_URL.includes(to.path) || to.path.startsWith(JOIN_URL)) {
    next()
  } else if (store.getters.globalErrorStatus || store.getters.denyCode) {
    let target = store.getters.globalErrorStatus ? '/com-error' : '/exp-error'
    if (from.path !== target) {
      next(target)
    }
  } else {
    if (VueCookies.isKey('dms-user-token')) {
      const decToken = VueJwtDecode.decode(VueCookies.get('dms-user-token'))
      if (decToken) {
        const expDate = decToken.exp * 1000
        const now = new Date().getTime()
        if (now >= expDate) {
          await store.dispatch('getToken')
        }

        if (store.getters.userKey === '') {
          // 기본정보 적재 (데이터가 너무 많아서 동기처리- 이거 먼저 불러주기 싫음. 바꿔주자.)
          await store.dispatch('getUserInfo')
          await store.dispatch('getMemberInfo')
          // 사용티켓으로 계약/상품정보 조회
          await store.dispatch('getContractedGoodsInfo')
          store.dispatch('getTodayPlanList')
          store.dispatch('getUseOrdDtl')

          pageIntercept(next, to)
        } else {
          next()
        }
      } else {
        if (WHITE_URL.includes(to.path) || to.path.startsWith(JOIN_URL)) {
          next()
        } else if (store.getters.globalErrorStatus || store.getters.denyCode) {
          let target = store.getters.globalErrorStatus ? '/com-error' : '/exp-error'
          if (from.path !== target) {
            next(target)
          }
        } else {
          await store.dispatch('getToken')
          next({...to, replace: true})
        }
      }
    } else {
      if (WHITE_URL.includes(to.path) || to.path.startsWith(JOIN_URL)) {
        next()
      } else if (store.getters.globalErrorStatus || store.getters.denyCode) {
        let target = store.getters.globalErrorStatus ? '/com-error' : '/exp-error'
        if (from.path !== target) {
          next(target)
        }
      } else {
        await store.dispatch('getToken')
        next({...to, replace: true})
      }
    }
  }
})


/**
 * 페이지별 인터셉트
 * 온보딩, 닉네임 등
 * @param next
 */
const pageIntercept = async (next, to) => {
  // Onboard 체크
  await store.dispatch('getObdCheckYn')
  await store.dispatch('getUserNickname')
  await store.dispatch('getUserSltCmplt')
  await store.dispatch('getServiceAgreementCheck')

  const { getters } = store;

  // 회원가입 - 동의서 조회 (삼성화재 제외)
  if (getters.applyYn === 'N' && getters.clientCd !== 'samsungfire') return next({ path: `${termsSheetUrl}/${getters.memberGb}`, replace: true });
  // 온보딩 체크
  if (getters.obdCheckYn !== 'Y') return next({ path: onBoardUrl, replace: true });
  // 닉네임 체크 (삼성화재용)
  if (!getters.nickname && getters.clientCd === 'samsungfire') return next({ path: onNickname, replace: true });
  if (getters.cmpltYn === 'Y' && getters.guideEvalYn === 'N' && getters.cmpltDt === null) return next({ path: travelCompleteUrl, replace: true });
  // 패스워드 6개월 주기 체크
  if (getters.changePasswordRequired) return next({ path: checkChangePasswordUrl, replace: true });

  next({ ...to, replace: true });
}

